import { useContext } from "react";
import { FieldErrors } from "react-hook-form";

import { ErrorLoggerContext } from "providers/ErrorLogger";

export default (): {
  reportErrors: (errors: FieldErrors, prefix?: string) => void;
  reportError: (context: string, error: unknown) => void;
} => {
  const { logger } = useContext(ErrorLoggerContext);

  const reportErrors = (errors: FieldErrors, prefix?: string) => {
    if (!errors) return;

    if (logger && Object.keys(errors).length > 0)
      Object.keys(errors).forEach((key) => {
        const error = errors[key];
        const field = prefix ? `${prefix}.${key}` : key;

        if (typeof error?.type === "string")
          logger.info(`validation failed @ ${field} : ${error.type}`);
        else reportErrors(error as FieldErrors, field);
      });
  };

  // For a caught error that the UI answers with a toast. The user is told
  // something failed; without this nobody else ever is.
  const reportError = (context: string, error: unknown) => {
    if (!logger) return;

    const cause = error instanceof Error ? error : undefined;

    logger.error(`${context}: ${cause?.message ?? String(error)}`, cause);
  };

  return { reportErrors, reportError };
};
